<section>
  <h3>{{"dashboard:Report Settings" | i18next}}</h3>
  <div class="section-content settings-content">
    <div class="properties-row">
      <app-widget-report-columns-select [items]="columns" class="half-row" bindLabel="shortDescription"
        [model]="gridItem.setup.columns" [defaultColumns]="columns" title="{{ 'dashboard:Select Columns' | i18next }}"
        bindValue="labelCode" (modelChange)="columnsModelChange($event)" [disabledColumns]="disabledColumns">
      </app-widget-report-columns-select>
      <app-widget-type-select [widgetType]="gridItem.type" [showTooltip]="true"
        (modelChange)="gridItem.type=$event;notifyReportModified()" class="half-row"
        title="{{ 'dashboard:Visual Type' | i18next }}" [disabledItems]="visualTypeDisabledItems" hideLabelType="true">
      </app-widget-type-select>
    </div>
    <div class="properties-row">
      <div class="width100pct">
        <div class="period-title">{{ 'dashboard:For Period' | i18next }}</div>
        <div class=" flex">
          <div class="half-row">
            <div class="label">{{ 'dashboard:From' | i18next }}</div>
            <div class="flex mr5">
              <app-relative-date-select [gridItem]="gridItem" model="from" [reportMaxDays]="100"
                [(completed)]="relativeFromCompleted" (completedChange)="dateSelectChange()" class="grow">
              </app-relative-date-select>
            </div>
          </div>
          <div class="half-row">
            <div class="label">{{ 'dashboard:To' | i18next }}</div>
            <div class="flex">
              <app-relative-date-select [gridItem]="gridItem" model="to" [(completed)]="relativeToCompleted"
                (completedChange)="dateSelectChange()" class="grow">
              </app-relative-date-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="properties-row">
      <div class="half-row">
        <app-widget-report-select [items]="ruleItems" bindLabel="ruleName" [model]="gridItem.setup.ruleIds"
          title="{{ 'dashboard:Select Rules' | i18next }}" bindValue="ruleId" [(exclude)]="gridItem.setup.excludeRules"
          (modelChange)="rulesModelChanged($event)" class="filter-select" (excludeChange)="modelChange()" >
        </app-widget-report-select>
      </div>
      <div class="half-row">
        <app-widget-report-select [items]="interactionItems" bindLabel="interactionName"
          [model]="gridItem.setup.interactionIds" title="{{ 'dashboard:Select Interactions' | i18next }}"
          bindValue="interactionId" [(exclude)]="gridItem.setup.excludeInteractions"
          (modelChange)="interactionsModelChanged($event)" class="filter-select" (excludeChange)="modelChange()" >
        </app-widget-report-select>
      </div>
    </div>
    <div class="properties-row">
      <div class="half-row">
        <div>
          <div class="title ml5">{{ 'dashboard:Group by time' | i18next }}</div>
          <ng-select [items]="sysGroupByTime" bindLabel="value" bindValue="key"
            [(ngModel)]="gridItem.setup.sysGroupByTime" placeholder="{{ 'Select'| i18next }}" [searchable]="false"
            class="group-select" (change)="notifyReportModified()">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
              <span>{{item.value}}</span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="item">{{item?.value}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="half-row"></div>
    </div>
  </div>
</section>
